import { LoadState } from "../../constants/enums";
import { IVariantsState, IVariant } from "./variants.types";

export const initialVariantsState: IVariantsState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
};

export const initialVariant: IVariant = {
  service_aline_uuid: null,
  name: "",
  price: 0,
  description: "",
  company_outlet_uuid: "",
  status: "ACTIVE",
  created_by_uuid: undefined,
  created_by_name: undefined,
  modified_by_uuid: null,
  modified_by_name: null,
};





